import { useNode } from '@craftjs/core';
import { Alert, Typography } from '@mui/material';
import {
	SliderControl,
	TextControl
} from 'pages/PageEditor/settingsComponents';
import { generateOnChange } from 'pages/PageEditor/settingsComponents/settingsHelpers';
import React, { useMemo } from 'react';
import { sizeOptions } from './editorCodeConstants';

const EditorInputSettings = () => {
	const {
		size,
		label,
		actions: { setProp }
	} = useNode((node) => node.data.props);

	const [onLabelChange, onSizeChange] = useMemo(
		() => ['label', 'size'].map((attr) => generateOnChange(setProp, attr)),
		[setProp]
	);

	return (
		<div>
			<Alert
				severity="info"
				sx={{
					alignItems: 'center'
				}}
				icon={false}
			>
				<Typography variant="body2">
					{intl.tr('screenEditor.settings.oneTimeCode.alert')}
				</Typography>
			</Alert>
			<TextControl
				value={label}
				label={intl.tr('screenEditor.settings.input.label')}
				setValue={onLabelChange}
			/>
			<SliderControl
				label={intl.tr('screenEditor.settings.input.size')}
				value={size}
				options={sizeOptions}
				setValue={onSizeChange}
				marks
			/>
		</div>
	);
};

export { EditorInputSettings };
